<template>
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <div
        :class="[classes, {'statusLamp__': true}]"
        :style="`width: 20px; height: 20px; border-radius: 50%; background-color: ${color}`"
        v-on="on"
      />
    </template>
    <span
      class="statusLamp--text"
      v-text="statusText"
    />
  </v-tooltip>
</template>

<script>
export default {
  props: {
    color: String,
    statusText: String,
    classes: String,
  },
}
</script>
